import { Component, input, ChangeDetectionStrategy } from '@angular/core';

const sizes = {
  xs: 16,
  sm: 24,
  md: 32,
  lg: 56,
  xl: 72,
};
type SpinnerSize = keyof typeof sizes;

const colors = {
  primary: 'stroke-primary',
  secondary: 'stroke-secondary',
};
type SpinnerColor = keyof typeof colors;

type SpinnerThickness = keyof typeof thicknesses;

const thicknesses = {
  xs: '1',
  sm: '2',
  md: '3',
  lg: '4',
  xl: '5',
};

type ContentPosition = 'top' | 'bottom' | 'left' | 'right';

@Component({
  selector: 'tvd-progress-spinner',
  host: { class: ' inline-block' },
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <div
      class="flex gap-2 items-center justify-center"
      [class]="positionClasses()"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        [attr.width]="size()"
        [attr.height]="size()"
        viewBox="0 0 24 24"
        fill="none"
        [attr.stroke-width]="thickness()"
        stroke-linecap="round"
        stroke-linejoin="round"
        [class]="color()"
        class="animate-spin"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M12 3a9 9 0 1 0 9 9" />
      </svg>
      <ng-content />
    </div>
  `,
})
export class ProgressSpinner {
  size = input<string, SpinnerSize>('32', {
    transform: (value: SpinnerSize) => `${sizes[value]}`,
  });
  color = input<string, SpinnerColor>('stroke-primary', {
    transform: (value: SpinnerColor) => colors[value],
  });
  thickness = input<string, SpinnerThickness>('3', {
    transform: (value: SpinnerThickness) => `${thicknesses[value]}`,
  });

  readonly positionClasses = input<string, ContentPosition>('flex-col', {
    alias: 'contentPosition',
    transform: (value) => {
      switch (value) {
        case 'top':
          return 'flex-col-reverse';
        case 'bottom':
          return 'flex-col';
        case 'right':
          return 'flex-row';
        case 'left':
          return 'flex-row-reverse';
        default:
          return 'flex-col';
      }
    },
  });
}
